/**
 * Sample goals shown to free accounts on the Goals tab. They demonstrate the
 * three goal types with realistic figures; nothing here is persisted.
 */
export const PREVIEW_GOALS = [
  {
    id: "preview-deadline",
    type: "deadline",
    status: "active",
    title: "Finish Avengers: Doomsday",
    readingOrderId: null,
    targetCount: 60,
    source: "film_release",
    endsOn: "2026-12-18",
    progress: {
      completed: 21,
      target: 60,
      percent: 35,
      expected: 24,
      expectedPercent: 40,
      delta: -3,
      paceStatus: "behind",
      daysRemaining: 12,
      requiredPerDay: 4,
      requiredMinutesPerDay: 60,
      projectedFinish: "2026-12-21",
      nudgeDate: null,
      orderGrewBy: 0,
    },
  },
  {
    id: "preview-rate",
    type: "rate",
    status: "active",
    title: "5 comics a week",
    targetCount: 5,
    period: "week",
    periodResetDay: 1,
    progress: {
      completed: 3,
      target: 5,
      paceStatus: "on_track",
      resetsLabel: "resets Monday",
    },
  },
  {
    id: "preview-yearly",
    type: "yearly",
    status: "active",
    title: "2026 challenge",
    targetCount: 250,
    progress: {
      completed: 150,
      target: 250,
      percent: 60,
      delta: 11,
      paceStatus: "ahead",
    },
  },
];

export const GOALS_PREMIUM_PITCH = {
  title: "Reading goals are a Premium feature",
  description:
    "Set a deadline for an order, a weekly pace or a yearly challenge, and see whether you are reading fast enough to get there.",
  points: [
    "Finish an order before a film or show lands",
    "Keep a daily, weekly or monthly reading pace",
    "Take on a yearly challenge and watch it fill up",
  ],
};
